export default "__VITE_ASSET__DpgyqNcw__"